const $ = jQuery.noConflict();

'use strict';

const Chat = {
	chatWindows: {},
	typingTimers: {},

	init: function() {
		if ($('.chat-container').length === 0) {
			$('body').append('<div class="chat-container"></div>');
		}

		// Open chat when clicking a user
		$('.js-user-chat').on('click', function() {
			const username = $(this).data('user-username');
			if (username !== window.currentUser) {
				Chat.openChat(username);
			}
		});

		// Send message on button click
		$(document).on('click', '.chat-send-btn', function() {
			const chatBox = $(this).closest('.chat-box');
			Chat.sendMessage(chatBox);
		});

		// Send message on Enter key (excluding Shift+Enter)
		$(document).on('keypress', '.chat-input', function(event) {
			if (event.which === 13 && !event.shiftKey) {
				event.preventDefault();
				const chatBox = $(this).closest('.chat-box');
				Chat.sendMessage(chatBox);
			} else {
				Chat.notifyTyping($(this).closest('.chat-box'));
			}
		});

		// Minimize chat window
		$(document).on('click', '.chat-header', function() {
			const chatBox = $(this).closest('.chat-box');
			chatBox.toggleClass('minimized');
		});

		// Close chat window completely
		$(document).on('click', '.chat-remove-btn', function(event) {
			event.stopPropagation();
			const chatBox = $(this).closest('.chat-box');
			const username = chatBox.data('username');
			delete Chat.chatWindows[username];
			chatBox.remove();
		});

		// Refresh messages every 3 seconds
		setInterval(Chat.refreshChats, 3000);

		// Fetch typing status every 1 seconds
		setInterval(Chat.fetchAllTypingStatuses, 1000);
	},

	openChat: function(username) {
		if (!username || username === window.currentUser) return;

		if (Chat.chatWindows[username]) {
			Chat.chatWindows[username].removeClass('minimized');
			return;
		}

		const chatBox = $(`
            <div class="chat-box" data-username="${username}">
                <div class="chat-header">
                    <span>${username}</span>
                    <button class="chat-remove-btn">×</button>
                </div>
                <div class="chat-messages"></div>
                <div class="typing-indicator hidden">Korisnik kuca...</div>
                <div class="chat-input-container">
                    <input type="text" class="chat-input" placeholder="Type a message..." autocomplete="off">
                    <button class="chat-send-btn">Send</button>
                </div>
            </div>
        `).appendTo('.chat-container');

		Chat.chatWindows[username] = chatBox;
		Chat.fetchMessages(chatBox);
		Chat.markMessagesAsRead(username);
	},

	fetchMessages: function(chatBox) {
		const username = chatBox.data('username');
		const chatMessages = chatBox.find('.chat-messages');

		const wasAtBottom = chatMessages.data('autoScroll') === undefined ? true : chatMessages.data('autoScroll');

		$.get(`/wp-json/office-pulse-api/v1/chat/get?user1=${window.currentUser}&user2=${username}`)
			.done(function(response) {
				if (response.success) {
					chatMessages.html('');

					response.messages.forEach(msg => {
						Chat.displayMessage(chatBox, msg.sender_username, msg.message, msg.id, msg.is_read);
					});

					if (wasAtBottom) {
						chatMessages.scrollTop(chatMessages[0].scrollHeight);
					}

					Chat.markMessagesAsRead(username); // Mark as read when messages are fetched
				}
			})
			.fail(function(error) {
				console.error('AJAX Error:', error);
			});
	},

	sendMessage: function(chatBox) {
		const message = chatBox.find('.chat-input').val().trim();
		if (!message) return;

		const username = chatBox.data('username');
		const messageId = `msg-${Date.now()}`;

		const data = {
			sender: window.currentUser,
			receiver: username,
			message: message
		};

		$.ajax({
			url: '/wp-json/office-pulse-api/v1/chat/send',
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify(data),
			success: function(response) {
				if (response.success) {
					Chat.markMessageAsDelivered(messageId);
				} else {
					console.error('Failed to send message:', response.error);
				}
			},
			error: function(xhr) {
				console.error('AJAX Error:', xhr.responseText);
			}
		});

		chatBox.find('.chat-input').val('');
		Chat.displayMessage(chatBox, window.currentUser, message, messageId, false);
	},

	/** Updates the checkmark when a message is delivered */
	markMessageAsDelivered: function(messageId) {
		const messageElement = $(`.chat-message[data-id="${messageId}"]`);
		if (messageElement.length > 0) {
			messageElement.find('.message-status').text('✓✓').addClass('delivered');
		}
	},

	/** Marks messages as read when the receiver opens the chat */
	markMessagesAsRead: function(receiver) {
		$.ajax({
			url: '/wp-json/office-pulse-api/v1/chat/read',
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				sender: receiver,
				receiver: window.currentUser
			}),
			success: function() {
				$('.chat-message').each(function() {
					if ($(this).attr('data-id')) {
						$(this).find('.message-status')
							.text('✓✓')
							.removeClass('delivered')
							.addClass('read');
					}
				});
			},
			error: function(xhr) {
				console.error('Failed to mark messages as read:', xhr.responseText);
			}
		});
	},

	notifyTyping: function(chatBox) {
		const username = chatBox.data('username');
		const inputField = chatBox.find('.chat-input');

		if (inputField.val().trim() === '') {
			return;
		}

		$.ajax({
			url: '/wp-json/office-pulse-api/v1/chat/typing',
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				sender: window.currentUser,
				receiver: username,
				is_typing: true
			})
		});

		clearTimeout(chatBox.data('typingTimeout'));
		chatBox.data('typingTimeout', setTimeout(() => {
			$.ajax({
				url: '/wp-json/office-pulse-api/v1/chat/typing',
				type: 'POST',
				contentType: 'application/json',
				data: JSON.stringify({
					sender: window.currentUser,
					receiver: username,
					is_typing: false
				})
			});
		}, 3000));
	},

	/** Fetch typing status for all open chats */
	fetchAllTypingStatuses: function() {
		$('.chat-box').each(function() {
			Chat.fetchTypingStatus($(this));
		});
	},

	fetchTypingStatus: function(chatBox) {
		const username = chatBox.data('username');
		const typingIndicator = chatBox.find('.typing-indicator');

		$.get(`/wp-json/office-pulse-api/v1/chat/typing?sender=${username}&receiver=${window.currentUser}`)
			.done(function(response) {
				if (response.success && response.is_typing) {
					typingIndicator.removeClass('hidden');
				} else {
					typingIndicator.addClass('hidden');
				}
			})
			.fail(function(error) {
				console.error('Failed to fetch typing status:', error);
			});
	},

	refreshChats: function() {
		$('.chat-box').each(function() {
			Chat.fetchMessages($(this));
		});
	},

	displayMessage: function(chatBox, sender, message, messageId = '', isRead = false) {
		const chatContent = chatBox.find('.chat-messages');

		if ($(`.chat-message[data-id="${messageId}"]`).length > 0) {
			return;
		}

		const isSender = sender === window.currentUser;
		const messageClass = isSender ? 'sent' : 'received';
		const checkmarkClass = isRead ? 'read' : 'delivered';
		const initials = sender.substring(0, 2).toUpperCase();

		const messageHtml = `
            <div class="chat-message ${messageClass}" data-id="${messageId}">
                <div class="chat-avatar">${initials}</div>
                <div class="chat-bubble">
                    ${message}
                    <span class="message-status ${checkmarkClass}">✓</span>
                </div>
            </div>
        `;

		chatContent.append(messageHtml);
	}
};

export default Chat;
